export const calculateLoanAmountFromEMI = (
  emi: number,
  interest: number,
  tenure: number
) => {
  const r = interest / 12 / 100;
  return Math.round((emi * (1 - Math.pow(1 + r, -tenure))) / r);
};

export const calculateEMIFromLoanAmount = (
  loan: number,
  interest: number,
  tenure: number
) => {
  const r = interest / 12 / 100;
  return Math.round(
    (loan * r * Math.pow(1 + r, tenure)) / (Math.pow(1 + r, tenure) - 1)
  );
};
